import React, { useRef } from "react";

function UploadScreen({ onFileChange, onUpload, file }) {
  const inputRef = useRef(null);

  const handleSelectClick = () => {
    inputRef.current.click();
  };

  return (
    <div className="container">
      <div className="textContainer">
        <h1 className="titulo">
          Seja bem-vindo ao <span>Audio Split X</span>!
        </h1>
        <h2>Seu separador de áudio gratuito!</h2>
        <p className="subtitulo">
          Separe a voz e o instrumental de qualquer música com facilidade e
          qualidade.
        </p>
      </div>

      <div className="buttonsContainer">
        <input
          type="file"
          accept="audio/*"
          ref={inputRef}
          style={{ display: "none" }}
          onChange={onFileChange}
        />

        <button onClick={handleSelectClick}>Selecionar arquivo</button>

        {file && (
          <button style={{ marginTop: "15px" }} onClick={onUpload}>
            SEPARAR
          </button>
        )}
      </div>
    </div>
  );
}

export default UploadScreen;
